import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper height100" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center height100"
}
const _hoisted_3 = { class: "body-2 blue-grey--text" }
const _hoisted_4 = { class: "body-2 blue-grey--text" }
const _hoisted_5 = { class: "body-2 blue-grey--text" }
const _hoisted_6 = { class: "d-flex justify-center my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_vue_loading, {
            loader: "bars",
            color: "#EE6090",
            size: { width: '50px', height: '50px' }
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          fluid: "",
          class: "height100"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, { class: "pt-5" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.t('familyCreate.description.line1')), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.t('familyCreate.description.line2')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.t('familyCreate.description.line3')), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.t('familyCreate.description.line4')), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('familyCreate.childId')), 1),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.postFamilyRequest.childCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postFamilyRequest.childCode) = $event)),
                    outlined: "",
                    dense: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t('familyCreate.password')), 1),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.postFamilyRequest.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postFamilyRequest.password) = $event)),
                    outlined: "",
                    dense: "",
                    type: "password"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t('familyCreate.parentType')), 1),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.postFamilyRequest.parentType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postFamilyRequest.parentType) = $event)),
                    items: _ctx.parentTypes,
                    "item-title": "text",
                    "item-value": "value",
                    outlined: "",
                    dense: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.postFamily,
                    loading: _ctx.btnLoading,
                    color: "primary",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('familyCreate.submit')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.logout,
                    color: "primary",
                    outlined: "",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('familyCreate.logout')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}